export const projects = [
  {
    img: "https://www.91-cdn.com/hub/wp-content/uploads/2022/06/Best-chatting-apps.png",
    title: "ChatApp Mern",
    des: "chat application that enables real-time messaging. With this chat application, users have the ability to engage in one-to-one conversations or participate in group chats. This means that messages can be sent and received instantly, making it convenient for users to communicate with one another.",
    demo: "",
    live: "https://chatapp-mern1.netlify.app/",
    gitHub: "https://github.com/vinayakpagar23/ChatApp-Mern",
    technologies: [
      "HTML",
      "CSS",
      "JavaScript",
      "React","ContextAPI","Chakra-UI","Node js","MongoDb","Express js","Mongoose","socket.io"
      
    ], 
  },

  {
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTB2VBe3SqLfBphw0ocRQzhJD-uQ-eztYwjxA&usqp=CAU",
    title: "Social Media App",
    des: "added authentication, so users can now log in and sign up. Additionally, users can view posts from other users, like them, and add their own posts to the platform. The app also offers the ability to switch between light and dark themes for a personalized experience.",
    demo: "",
    live: " https://quiet-caramel-f3aa42.netlify.app/",
    gitHub: "https://github.com/vinayakpagar23/socialMedia-mern",
    technologies: [
      "HTML",
      "CSS",
      "JavaScript",
      "React","Redux","Material UI","Node js","MongoDb","Express js","Mongoose"
      
    ], 
  },
  {
    img: "https://i0.wp.com/nenow.in/wp-content/uploads/2020/02/Flipkart.jpg?fit=1030%2C687&ssl=1",
    title: "Flipkart.com Clone",
    des: "E-Commerce website where we can buy any type of products",
    demo: "",
    live: "https://flipkart-clone-masai.netlify.app/",
    gitHub: "https://github.com/PrathmeshVK/Flipkart_Clone",
    technologies: [
      "HTML",
      "CSS",
      "JavaScript",
      "React","Redux","Material-UI","Chakra-UI"
      
    ],

    
  },
  {
    img: "https://camo.githubusercontent.com/291a70054a63bd9ed5e6ef9cbe506dee2483734bdb84f5e4781ece115727134a/687474703a2f2f70686f746f732e70726e657773776972652e636f6d2f70726e66756c6c2f32303135303230312f313732373131",
    title: "Freshly.Com Clone",
    des: "With Freshly, you’ll enjoy the convenience of nutritious, prepared meals delivered right to your door. We’ve done the planning, prepping, and cooking, so all you have to do is heat your meal, savor every flavor, and decompress from the day. Thoughtful Ingredients; Effortless Nutrition. We believe better eating should be easy for everyone.",
    demo: "",
    live: "https://creative-baklava-88fc32.netlify.app",
    gitHub: "https://github.com/Meshabaz/freshly-clone",
    technologies: [
      "HTML",
      "CSS",
      "JavaScript",
      "BootStrap","LocalHost","JSON-Server"
      
    ],
  },
  {
    img: "https://entrackr.com/storage/2020/08/netmeds-1-800x400.jpg",
    title: "Netmed.com Clone",
    des: "Cretaed clone of netmeds.com. The main purpose of this website is deliver medicine as lowest price and quick. This was a collaborative project buit by team of 5 members in 5 days.",
    
    demo: "",
    live: "https://mellifluous-banoffee-ac4abc.netlify.app/",
    gitHub: "https://github.com/GryffindorAdi/netmed",
    technologies: ["HTML", "CSS", "JavaScript","LocalHost", "JSON"],
  },
  
  {
    img: "https://www.androidauthority.com/wp-content/uploads/2021/05/Rocket-Player-screenshot-2022.jpg",
    title: "Music Player App",
    des: "this is music player App where We can play , pause , and change the the music",
    demo: "",
    live: "https://venerable-blancmange-fd9e89.netlify.app/",
    gitHub: "https://github.com/vinayakpagar23/Music-Player/tree/main/music%20player",
    technologies: [
      "HTML",
      "CSS",
      "JavaScript"
      
    ],
  },
  {
    img: "https://res.cloudinary.com/practicaldev/image/fetch/s--UIJ-rWtg--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/qurdui0uny9p0c18dimb.png",
    title: "Google note clone",
    des: "This is google note clone, here we can add , delete and edit our note",
    demo: "",
    live: "https://willowy-bavarois-8c792a.netlify.app/",
    gitHub: "https://github.com/vinayakpagar23/Google-note/tree/main/google%20node",
    technologies: [
      "HTML",
      "CSS",
      "JavaScript","LocalHost"
      
    ],
  }
];
